import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Button } from "@heroui/react";
import thinkingImage from "../assets/img/mashking/thinking.png";

export default function Maintenance() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background dark:bg-mash-black flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Mashking thinking Image */}
        <div className="mx-auto">
          <img
            src={thinkingImage}
            alt="Mash Character"
            className="w-32 h-32 mx-auto object-contain"
          />
        </div>

        {/* Main Message */}
        <div className="space-y-4">
          <p className="text-gray-300 text-lg">
            Mash is down but we&apos;re working on it and we&apos;ll be back
            online soon.
          </p>
          <p className="text-gray-400">Thanks for your patience.</p>
        </div>

        {/* Refresh Button */}
        <Button
          color="primary"
          className="gradient-wild-bg"
          onPress={handleRefresh}
          startContent={<ArrowPathIcon className="w-4 h-4" />}
        >
          Check Again
        </Button>
      </div>
    </div>
  );
}
